import { jsx, jsxs } from "react/jsx-runtime";
import { CdnIcon, Divider, IconToggleButton, Image, cn } from "@pcln/horizon";
import { recentSelectionVariants } from "../../RecentSelection.variants.js";
import { CTAButtons, DateBlock, PriceSection, ReviewsSection } from "../../common/shared.js";
function HotelSelection({ buttonText = 'Book Now', checkIn, checkOut, className, headline, imageSrc, isFavorite, locationText, onClick, onFavoriteToggle, price, reviews, subheadline, starRating }) {
    const resolvedLocationText = locationText ?? subheadline ?? '';
    const { attributeRow, bottomSection, card, contentWrapper, dateBlockDividerHorizontal, dateBlockDividerVertical, dateBlocksContainer, favoriteButton, image, imageContainer, infoSection, middleSection, root, subtitle, title, topSection } = recentSelectionVariants({
        hasPrice: Boolean(price),
        productType: 'hotels'
    });
    return /*#__PURE__*/ jsx("div", {
        className: cn(root(), className),
        children: /*#__PURE__*/ jsx("div", {
            className: card(),
            onClick: onClick,
            children: /*#__PURE__*/ jsxs("div", {
                className: contentWrapper(),
                children: [
                    /*#__PURE__*/ jsxs("div", {
                        className: topSection(),
                        children: [
                            onFavoriteToggle && /*#__PURE__*/ jsx("div", {
                                className: favoriteButton(),
                                children: /*#__PURE__*/ jsx(IconToggleButton, {
                                    ariaLabel: "Favorite this hotel",
                                    emphasis: "bold",
                                    isAnimated: true,
                                    isToggledOn: isFavorite,
                                    onToggle: onFavoriteToggle,
                                    palette: "favorite",
                                    size: "24"
                                })
                            }),
                            /*#__PURE__*/ jsx("div", {
                                className: imageContainer(),
                                children: /*#__PURE__*/ jsx(Image, {
                                    alt: headline,
                                    className: image(),
                                    objectFit: "cover",
                                    src: imageSrc
                                })
                            }),
                            /*#__PURE__*/ jsxs("div", {
                                className: infoSection(),
                                children: [
                                    /*#__PURE__*/ jsx("div", {
                                        className: title(),
                                        children: headline
                                    }),
                                    /*#__PURE__*/ jsxs("div", {
                                        className: attributeRow(),
                                        children: [
                                            /*#__PURE__*/ jsx(CdnIcon, {
                                                className: "text-neutral-10",
                                                iconName: "location_on",
                                                size: "16"
                                            }),
                                            /*#__PURE__*/ jsx("div", {
                                                className: subtitle(),
                                                children: resolvedLocationText
                                            })
                                        ]
                                    }),
                                    reviews && /*#__PURE__*/ jsx(ReviewsSection, {
                                        reviews: reviews,
                                        starRating: starRating
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("div", {
                        className: middleSection(),
                        children: [
                            /*#__PURE__*/ jsxs("div", {
                                className: dateBlocksContainer(),
                                children: [
                                    /*#__PURE__*/ jsx(DateBlock, {
                                        dateInfo: checkIn,
                                        label: "Check-in",
                                        productType: "hotels"
                                    }),
                                    /*#__PURE__*/ jsx(Divider, {
                                        className: dateBlockDividerVertical(),
                                        direction: "vertical"
                                    }),
                                    /*#__PURE__*/ jsx(Divider, {
                                        className: dateBlockDividerHorizontal(),
                                        direction: "horizontal"
                                    }),
                                    /*#__PURE__*/ jsx(DateBlock, {
                                        dateInfo: checkOut,
                                        label: "Check-out",
                                        productType: "hotels"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ jsxs("div", {
                                className: bottomSection(),
                                children: [
                                    price && /*#__PURE__*/ jsx(PriceSection, {
                                        price: price
                                    }),
                                    /*#__PURE__*/ jsx(CTAButtons, {
                                        buttonText: buttonText,
                                        onClick: onClick
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
export { HotelSelection };
